import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          cols: "4",
          class: "offset-4"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("h6", null, "Select Groups to Spoof", -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupMatrix, (groupRow) => {
      return (_openBlock(), _createBlock(_component_b_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupRow, (groupControl) => {
            return (_openBlock(), _createBlock(_component_b_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_checkbox_input, {
                  label: groupControl.group.userGroupName,
                  modelValue: groupControl.active,
                  "onUpdate:modelValue": ($event: any) => ((groupControl.active) = $event)
                }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 2
      }, 1024))
    }), 256)),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          cols: "4",
          class: "offset-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_button, { onClick: _ctx.setSpoof }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Set Groups")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          cols: "4",
          class: "offset-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_button, { onClick: _ctx.emitCancel }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}